<template>
  <div :style="{ textAlign: currentField.alignment }">
    <div>
      <div
          class="heading"
          :style="{ fontSize: currentField.size + 'px' }"
          v-html="displayText"
      ></div>
    </div>

    <a
        v-if="shouldShowToggle"
        href=""
        @click.prevent="toggleShowMore"
    >
      {{ showMore ? "View less" : "View more" }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'Paragraph',
  props: {
    currentField: { type: Object, required: true },
  },
  data() {
    return {
      showMore: false,
      maxCharacters: 200,
    };
  },
  computed: {
    isReport() {
      return this.currentField.print;
    },
    displayText() {
      if (this.currentField.print || this.showMore) {
        return this.currentField.paragraph;
      }
      return this.currentField.paragraph?.slice(0, this.maxCharacters) || '';
    },
    shouldShowToggle() {
      return (
          !this.currentField.print &&
          this.currentField.paragraph &&
          this.currentField.paragraph.length > this.maxCharacters
      );
    }
  },
  mounted() {
    this.$hub.$on('setParagraphContentLength', (data) => {
      this.maxCharacters = data.maxCharacters;
    });

  },

  methods: {
    toggleShowMore() {
      this.showMore = !this.showMore;
    },
  }
};
</script>

<style scoped>
.heading p {
  text-align: justify;
  letter-spacing: 0.5px;
}
</style>
